const serviceType = {
    USER_SERVICE: '/usapi.cgi',
    PAY_SERVICE: '/payapi.cgi',
    MOBILE_SERVICE: '/mbapi.cgi',
    GA_SERVICE: '/usapi.cgi',
    LOTTERY_SERVICE: '/ltapi.cgi',
};

export default serviceType;
